import { Stack, Typography, useTheme } from "@mui/material";
import { useCallback } from "react";

const BlogDetailsBody = ({subSections}) => {
    const theme = useTheme();

    const isABulletPoint = useCallback((content) => {
        return content.length > 0 && content[0] === "*";
    }, []);

    return (
        <>
            <Stack
                direction='column'
                py={{xs: 2, md: 4}}
                spacing={{xs: 2, md: 4}}
            >
                {
                    subSections.map((item, index) => {
                        return <Stack
                            key={index}
                            direction='column'
                            justifyContent='start'
                            alignItems='start'
                            width='100%'
                            spacing={{xs: 1, md: 1.5}}
                        >  
                            <Typography
                                fontWeight={600}
                                fontSize={{xs: 12, md: 16}}
                                textAlign='left'
                                color={theme.palette.text.primary}
                                lineHeight={1.5}
                            >
                                {item.heading}
                            </Typography>

                            {
                                item.content.map((content, indexContent) => {
                                    return <div key={indexContent}>
                                        {
                                            isABulletPoint(content)
                                            ?
                                            <Stack
                                                direction='row'
                                                justifyContent='start'
                                                alignItems='start'
                                            >
                                                <Typography
                                                    fontWeight={600}
                                                    fontSize={{xs: 12, md: 14}}
                                                    textAlign="justify"
                                                    lineHeight={1.5}
                                                    color={theme.palette.text.secondary}
                                                    pl={{xs: 2, md: 5}}
                                                    pr={2}
                                                >
                                                    -
                                                </Typography>

                                                <Typography
                                                    fontWeight={500}
                                                    fontSize={{xs: 12, md: 14}}
                                                    textAlign="justify"
                                                    lineHeight={1.5}
                                                    color={theme.palette.text.secondary}
                                                >
                                                    {content.substring(1)}
                                                </Typography>
                                            </Stack>
                                            :
                                            <Typography
                                                fontWeight={400}
                                                fontSize={{xs: 12, md: 14}}
                                                textAlign="justify"
                                                lineHeight={1.5}
                                                color={theme.palette.text.secondary}
                                            >
                                                {content}
                                            </Typography>
                                        }
                                    </div>
                                }) 
                            }

                            {
                                item.image
                                ?
                                <img 
                                    src={item.image}
                                    alt="Banner" 
                                    width='100%'
                                    style={{
                                        borderRadius: 32,
                                        paddingTop: '10px',
                                        paddingBottom: '10px'
                                    }}
                                />
                                :
                                <></>
                            }
                        </Stack>
                    })
                }
            </Stack>
        </>
    );
}

export default BlogDetailsBody;